"use client";
import { getFooterMenu, getRGPBanner } from "./request/requestList";
import { useEffect, useState } from "react";
import "./Footer.scss";
import { useLanguage } from "@/app/utils/LanguageContext";
import { useMediaQuery } from "@mui/material";
import { theme } from "./utils/Common";
import "./comm.scss";

type propType = {
  data?: any;
};

const Footer = (props: propType) => {
  const { state: lang } = useLanguage();
  const { t, langCode } = lang;
  const [isOpen, setIsOpen] = useState<any>([]);
  const setIsOpenHandle = (index: any) => {
    let currentOpen = !isOpen[index];

    let reSetOpen = [];
    reSetOpen[index] = currentOpen;

    setIsOpen([...reSetOpen]);
  };

  const [footerMenu, setFooterMenu] = useState<any>(null);
  const [footerRGBbanner, setFooterRGBbanner] = useState<any>(null);
  const [htmlText, setHtmlText] = useState<any>(null);
  const [htmlFragment, setHtmlFragment] = useState<any>(null);
  //get CMS Data
  useEffect(() => {
    getFooterMenu({
      language: langCode,
    }).then((res) => {
      setFooterMenu(res?.item);
      console.log("footer menu", res);
    });

    getRGPBanner({
      language: langCode,
    }).then((res) => {
      setFooterRGBbanner(res?.item?.RGPBanner);
      console.log("RGP banner", res);
    });
  }, []);
  useEffect(() => {
    const htmlText = footerMenu?.sitemap.value;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    setHtmlText(footerMenu?.sitemap.value);
    setHtmlFragment(doc.body.firstChild);
  }, [footerMenu]);
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
  const getAutoWidth = (): any => {
    return isMobile ? { width: "auto" } : {};
  };
  return (
    <>
      <div id="seo" className="fiveCol">
        <div style={getAutoWidth()} className="content">
          {htmlText == null || htmlText == "" ? (
            <></>
          ) : (
            [...htmlFragment?.children].map((item, index) => {
              return (
                <>
                  {item.tagName !== "DL" ? (
                    <span
                      dangerouslySetInnerHTML={{ __html: item.outerHTML }}
                    ></span>
                  ) : (
                    <dl className={`${isOpen[index] ? "isOpen" : ""}`}>
                      <dt
                        onClick={() => {
                          setIsOpenHandle(index);
                        }}
                      >
                        {item?.firstElementChild.textContent}{" "}
                        <span className={`open-button`}></span>
                      </dt>
                      {[...item?.children].map((itemdd, indexdd) => {
                        return itemdd.tagName === "DD" ||
                          itemdd.tagName === "UL" ? (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: itemdd.outerHTML,
                            }}
                          ></span>
                        ) : (
                          <></>
                        );
                      })}
                    </dl>
                  )}
                </>
              );
            })
          )}
        </div>
      </div>
      <div style={{ width: isMobile ? "100%" : "1000px;" }} className="footer">
        <div
          className="commBContent"
          style={{ padding: isMobile ? "12px 12px 0 12px" : "0 16px" }}
        >
          <span
            dangerouslySetInnerHTML={{ __html: footerRGBbanner?.rendered }}
            id="footer-top"
          ></span>
          <div
            className="footer-buttom"
            dangerouslySetInnerHTML={{ __html: footerMenu?.bottomlink.value }}
            id="footer-bottom"
          ></div>
        </div>
      </div>
    </>
  );
};

export default Footer;
